/* eslint-disable arrow-body-style */
import { config } from '@abyss/web/tools/config';

const eventSearchApiBase = config('EVENT_SEARCH_APP_URL');
const linkAnalysisApiBase = config('LINK_ANALYSIS_APP_URL');
const riskScoresApiBase = config('RISK_SCORES_APP_URL');
const middlewareApiBase = config('MIDDLEWARE_API_URL');

export const ApiUrl = {
  graphQl: () => `${middlewareApiBase}/api/graphql`,
  apiGroups: () => `${middlewareApiBase}/api/graphql?q=Groups`,
  apiUser: () => `${middlewareApiBase}/api/graphql?q=User`,
  apiLogout: () => `${middlewareApiBase}/api/graphql?q=Logout`,
  publishNessEvent: () => `${middlewareApiBase}/api/graphql?q=Publish`,

  // Event Search
  eventSearch: `${eventSearchApiBase}/app/events/search`,
  eventCuration: `${eventSearchApiBase}/app/events/search-summary`,
  eventDetail: (id: string) => `${eventSearchApiBase}/app/events/${id}`,
  portals: `${eventSearchApiBase}/app/portals`,
  eventTypes: `${eventSearchApiBase}/app/event-types`,

  // Link Analysis
  laProducts: `${linkAnalysisApiBase}/app/products`,
  laNodeTypes: `${linkAnalysisApiBase}/app/node-types`,
  laEdges: `${linkAnalysisApiBase}/app/edges/search`,
  laNodes: `${linkAnalysisApiBase}/app/nodes/search`,

  // Risk Scores
  riskScores: `${riskScoresApiBase}/app/fraud-risk-scores/search`,
  riskScoreFraudTypes: `${riskScoresApiBase}/app/fraud-pattern-types`,
};
